import request from '@/utils/request';
import { ResCode, CommonResponse, PagingResData, PagingReq, Company } from './baseDefine';
export interface SendDeviceCommandReq {
    meterID: string;
    comandType: string;
    data: string;
}
export interface SetScheduleJsonReq {
    meterID: string
    content: string;
    schedule: number
}

export interface GetScheduleJsonReq{
    meterID: string
}
export interface GetScheduleJsonRes extends CommonResponse {
    data:GetScheduleJsonResData
}
export interface GetScheduleJsonResData {
    meterID: string
    content: string;
    schedule: number;
    nextTime:number;
}
export interface GetConfigResponse extends CommonResponse {
    data: any
}

export function sendDeviceCommand(req: SendDeviceCommandReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/device/sendCommand', req);
}


export function getConfig(): Promise<GetConfigResponse> {
    return request.get<GetConfigResponse>('/api/device/config', null);
}

export function setScheduleJson(req: SetScheduleJsonReq): Promise<CommonResponse> {
    return request.post<CommonResponse>('/api/device/scheduleJson', req);
}

export function getScheduleJson(req: GetScheduleJsonReq): Promise<GetScheduleJsonRes> {
    return request.post<GetScheduleJsonRes>('/api/device/getScheduleJson', req);
}